import { CHANGE_PASSWORD_ERROR, CHANGE_PASSWORD_SUCCESS } from 'actions';
import { ChangePasswordActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function changePassword(action$: Observable<any>) {
  return action$.pipe(
    ofType(ChangePasswordActionTypes.CHANGE_PASSWORD),
    switchMap(action => {
      const { old_password, new_password, password_repeat } = action.payload;
      return ObservableAjax({
        until$: action$.pipe(ofType(ChangePasswordActionTypes.CHANGE_PASSWORD)),
        onSuccess: CHANGE_PASSWORD_SUCCESS,
        onError: CHANGE_PASSWORD_ERROR,
        onErrorMessage: 'Cannot change password',
        link: hitApi('put', 'api/auth/password-change/', { old_password, new_password, password_repeat }),
      });
    })
  );
}
